import React from "react"
import { Box, Text } from "UI"
import { CustomServicesBlock } from "../../Services"
import { HeaderWrapper } from "./style"

const ContentCards = (props) => {
  const { heading, items } = props || {}

  return (
    <Box
      width={["100%", null]}
      maxWidth="1160px !important"
      marginTop={["40px !important", null, "60px !important"]}
      marginBottom={["40px !important", null, "60px !important"]}
    >
      <HeaderWrapper>
        {heading && (
          <Text as="h2" fontSize={[28, null, 36]} textAlign="center">
            {heading}
          </Text>
        )}
      </HeaderWrapper>

      <CustomServicesBlock items={items} />
    </Box>
  )
}

export default ContentCards
